var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditorNavHomeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3063_14779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0006 19.0007V14.0007H14.0006V19.0007C14.0006 19.5507 14.4506 20.0007 15.0006 20.0007H18.0006C18.5506 20.0007 19.0006 19.5507 19.0006 19.0007V12.0007H20.7006C21.1606 12.0007 21.3806 11.4307 21.0306 11.1307L12.6706 3.6007C12.2906 3.2607 11.7106 3.2607 11.3306 3.6007L2.97059 11.1307C2.63059 11.4307 2.84059 12.0007 3.30059 12.0007H5.00059V19.0007C5.00059 19.5507 5.45059 20.0007 6.00059 20.0007H9.00059C9.55059 20.0007 10.0006 19.5507 10.0006 19.0007Z",
    fill: "#535353"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3063_14779"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorNavHomeIcon);
export default __webpack_public_path__ + "static/media/editor-nav-home-icon.739bf7a7cb6f9d7c15890151efe55b5a.svg";
export { ForwardRef as ReactComponent };